// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".price[data-v-11676f5e]{font-family:\"Montserrat\",sans-serif;font-weight:300;font-size:2rem}.price small[data-v-11676f5e]{text-decoration:line-through!important;color:red}h1[data-v-11676f5e]{margin:0}h1 small[data-v-11676f5e]{color:red}.description ul[data-v-11676f5e]{padding:0!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
